const isVideo = require('is-video')

const stripQueryStringAndHashFromPath = url => url.split('?')[0].split('#')[0]

const createShader = (gl, src, type) => {
    const shader = gl.createShader(type)

    gl.shaderSource(shader, src)
    gl.compileShader(shader)

    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        alert((type == gl.VERTEX_SHADER ? 'VERTEX' : 'FRAGMENT') + ' SHADER:\n' + gl.getShaderInfoLog(shader))
        return null
    }

    return shader
}

export const createProgram = (gl, vertex, fragment) => {
    const program = gl.createProgram()

    const vs = createShader(gl, vertex, gl.VERTEX_SHADER)
    const fs = createShader(gl, '#ifdef GL_ES\nprecision highp float;\n#endif\n\n' + fragment, gl.FRAGMENT_SHADER)

    if (vs == null || fs == null) return null

    gl.attachShader(program, vs)
    gl.attachShader(program, fs)

    gl.deleteShader(vs)
    gl.deleteShader(fs)

    gl.linkProgram(program)

    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        alert(
            'ERROR:\n' +
                'VALIDATE_STATUS: ' +
                gl.getProgramParameter(program, gl.VALIDATE_STATUS) +
                '\n' +
                'ERROR: ' +
                gl.getError() +
                '\n\n' +
                '- Vertex Shader -\n' +
                vertex +
                '\n\n' +
                '- Fragment Shader -\n' +
                fragment
        )

        return null
    }

    return program
}

export const removeProgram = ({ gl, texture, buffer, program }) => {
    gl.bindTexture(gl.TEXTURE_2D, null)
    gl.bindBuffer(gl.ARRAY_BUFFER, null)

    gl.deleteTexture(texture)
    gl.deleteBuffer(buffer)
    gl.deleteProgram(program)

    gl.canvas.width = 1
    gl.canvas.height = 1

    // Dispose of video on the dom
    if (texture.video) {
        texture.video.pause()
        texture.video.src = ''
        texture.video.load()
    }
}

export const createTexture = (gl, src, onload) => {
    const texture = gl.createTexture()

    if (isVideo(stripQueryStringAndHashFromPath(src))) {
        texture.video = document.createElement('video')
        texture.video.crossOrigin = 'anonymous'
        texture.video.preload = 'auto'
        texture.video.setAttribute('playsinline', '')

        texture.video.oncanplaythrough = () => {
            if (typeof onload === 'function') onload()
        }

        texture.video.src = src
    } else {
        texture.image = new Image()
        texture.image.crossOrigin = 'anonymous'

        texture.image.onload = () => {
            if (typeof onload === 'function' && onload() !== false) updateTexture(gl, texture, texture.image)
        }

        texture.image.src = src
    }

    return texture
}

export const updateTexture = (gl, texture, img) => {
    gl.bindTexture(gl.TEXTURE_2D, texture)
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true)
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, img)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE)
    gl.bindTexture(gl.TEXTURE_2D, null)
}

export const createBuffer = gl => {
    // Create Vertex buffer (2 triangles)
    const buffer = gl.createBuffer()

    gl.bindBuffer(gl.ARRAY_BUFFER, buffer)
    gl.bufferData(
        gl.ARRAY_BUFFER,
        new Float32Array([-1.0, -1.0, 1.0, -1.0, -1.0, 1.0, 1.0, -1.0, 1.0, 1.0, -1.0, 1.0]),
        gl.STATIC_DRAW
    )

    return buffer
}

export const renderPanorama = ({ gl, program, buffer, texture, vertexPosition, width, height, yaw, pitch, fov }) => {
    if (!program) return

    if (texture.video && isVideoPlaying(texture.video)) updateTexture(gl, texture, texture.video)

    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT)

    // Load program into GPU
    gl.useProgram(program)

    gl.bindTexture(gl.TEXTURE_2D, texture)

    // Set values to program variables
    gl.uniform2f(gl.getUniformLocation(program, 'resolution'), width, height)

    gl.uniform1f(gl.getUniformLocation(program, 'fov'), fov)
    gl.uniform1f(gl.getUniformLocation(program, 'yaw'), yaw)
    gl.uniform1f(gl.getUniformLocation(program, 'pitch'), pitch)

    // Render geometry
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer)
    gl.vertexAttribPointer(vertexPosition, 2, gl.FLOAT, false, 0, 0)
    gl.enableVertexAttribArray(vertexPosition)
    gl.drawArrays(gl.TRIANGLES, 0, 6)
    gl.disableVertexAttribArray(vertexPosition)
}

export const resizeViewPort = (gl, width, height) => {
    gl.viewport(0, 0, width, height)
}

export const requestAnimationFrame =
    window.requestAnimationFrame ||
    (function() {
        return (
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.oRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            function(callback, element) {
                window.setTimeout(callback, 1000 / 60)
            }
        )
    })()

export const cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame

export const isVideoPlaying = video =>
    !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2)
